<template>
  <div>
    <b-sidebar id="sidebar-right-new-entity" v-model="showNewEntityModal" bg-variant="white" right backdrop shadow>
      <NewOrganisationModalContent v-if="entityType === 'organisation'" />
      <NewGroupModalContent v-if="entityType === 'group'" />
      <NewUserModalContent v-if="entityType === 'user'" />
    </b-sidebar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VBToggle } from 'bootstrap-vue'
import { BSidebar } from 'bootstrap-vue'
import NewOrganisationModalContent from './NewOrganisationModalContent'
import NewGroupModalContent from './NewGroupModalContent.vue'
import NewUserModalContent from './NewUserModalContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSidebar,
    NewOrganisationModalContent,
    NewGroupModalContent,
    NewUserModalContent
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  computed: {
    ...mapState('homeAddNew', ['entityType']),
    showNewEntityModal: {
      get() {
        return this.$store.state.homeAddNew.showNewEntityModal
      },
      set(value) {
        this.$store.dispatch('homeAddNew/onChangeModal', { visible: value })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group-item {
  border: none !important;
}
</style>
